import moment from 'moment';

export interface IPost {
  excerpt: string;
  id: string;
  fields: {
    slug: string;
  };
  frontmatter: {
    title: string;
    tags: string[];
    templateKey: string;
    date: string;
    featuredpost: boolean;
    featuredimage: any;
  };
}

export class PostTools {
  static withTag(posts: IPost[], tag: string | undefined): IPost[] {
    const taggedPosts = tag
      ? posts.filter(post => {
          const { frontmatter } = post;
          return (
            frontmatter &&
            frontmatter.tags &&
            frontmatter.tags.findIndex(
              s => s.toLowerCase() === tag.toLowerCase()
            ) !== -1
          );
        })
      : posts;
    return taggedPosts;
  }

  static mostRecent(posts: IPost[], quantity: number = 5): IPost[] {
    return posts
      .sort((a, b) => {
        return moment(b.frontmatter.date).diff(a.frontmatter.date);
      })
      .filter((post, index) => {
        return index < quantity;
      });
  }

  static edgesToArray(result: any): IPost[] {
    return result.edges.map((edge: any) => edge.node);
  }
}
